import styled from "styled-components";
import buildColor from "@tvg-mar/tvg-promos-atomic-ui/_static/ColorPalette";

const ErrorPage = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${buildColor("white", "100")};
  height: 100%;

  @media screen and (width >= 1023px) {
    max-width: 800px;
    max-height: 712px;
    ${({ isDesktop }) => isDesktop && "min-height:70vh"};
    margin: auto;
    width: 100%;
  }

  @media screen and (width <= 1023px) {
    ${({ isDektop, isModal }) =>
      !isDektop && !isModal && "height: calc(100vh - 48px)"}
  }

  @media screen and (width >= 800px) and (width <= 1023px) {
    margin: 40px 72px;
  }

  @media (aspect-ratio >= 8/7) and (width >= 800px) and (width <= 1023px) {
    margin: 40px auto;
  }

  /* Portrait ratio */
  @media screen and (aspect-ratio <= 7/8) and (width >= 601px) and (width <= 1023px) {
    margin: 40px 72px;
  }

  /* Landscape ratio */
  @media screen and (aspect-ratio >= 8/7) and (width >= 800px) and (width <= 1023px) {
    margin: 40px auto;
  }
`;

export default ErrorPage;
